<!--
  banner 右上角的「规则」按钮
  设计稿：28x48 / 左侧圆角 4px（贴右边缘）/ padding 6 / gap 10
  / 底色 #2E51E5 60% / 背景模糊 4
  纵向位置 top 88.45px = 状态栏 + 导航条，所以 App 内直接跟 NavBar 底部对齐
-->
<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import { shouldShowNavBar } from "../../libs/chief-bridge";

  interface Props {
    onClick?: () => void;
  }

  let { onClick }: Props = $props();

  // NavBar 高度是固定 px（不参与 px2rem 缩放），这里也用 px 保持一致
  const topStyle = shouldShowNavBar()
    ? "top: var(--nav-bar-height, 88px);"
    : "top: 88px;";
</script>

<button type="button" class="rule-btn" style={topStyle} onclick={onClick}>
  {#each $t("activity_rules").split("") as char}
    <span>{char}</span>
  {/each}
</button>

<style>
  .rule-btn {
    position: absolute;
    right: 0;
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 28px;
    padding: 6px;
    border-radius: 4px 0 0 4px;
    /* 半透明底 #2E51E599 + 毛玻璃 blur 4 */
    background: #2e51e599;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    font-size: 14px;
    font-weight: 400;
    line-height: 13px;
    color: #ffffff;
  }
</style>
